import { atom } from 'recoil';

export const isUploadorEditBeforeAtom = atom({
  key: 'isUploadorEditBeforeAtom',
  default: false,
});
